var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss301(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1F72B5;}\r\n\t.st1{fill:#51A3DC;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#CECECE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st0",
    points: "145.7,401.1 122.5,140.7 377.5,140.7 354.3,401 249.8,430  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_10_",
    className: "st1",
    points: "250,407.9 334.4,384.5 354.3,162 250,162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_35_",
    className: "st2",
    points: "167.1,222.1 164,192 336,192 334,226.9 261.3,259 331,259 323.5,358 253.2,376.9  180.3,359.2 175.8,309 208,309 209.8,335.5 252,343.4 291,331.4 292.8,289 173,289 170.8,257.5 250,222.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_39_",
    className: "st3",
    points: "170.8,257.5 173,289 250,289 250,222.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_40_",
    className: "st3",
    points: "209.8,335.5 208,309 175.8,309 180.3,359.2 250,376.1 250,343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_41_",
    className: "st3",
    points: "164,192 167.1,222.1 250,222.8 250,192  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_34_",
    points: "274,82 274,70 226,70 226,98 259,98 259,107 225,107 225,118 273,118 273,89 239,89 239,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    points: "187,98.3 187,107 221,107 221,118 173,118 173,89.3 173,70 220,70 220,82 187,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_37_",
    points: "327,82 327,70 279,70 279,98 312,98 312,107 278,107 278,118 326,118 326,89 292,89 292,82  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss301);
export default __webpack_public_path__ + "static/media/CSS-3-01.bba0846c17cbd72752bd3deda1c1fdae.svg";
export { ForwardRef as ReactComponent };